import { Box, Stack, Text } from "@mantine/core";
import { ReactNode } from "react";

interface FormFieldProps {
  label: string;
  description?: string;
  children?: ReactNode;
  align?: "start" | "center" | "end";
}

export const FormField = ({ 
  label, 
  description, 
  children, 
  align = "start" 
}: FormFieldProps) => {
  return (
    <Stack gap={4} align={align}>
      <Box>
        <Text size="sm" fw={500} mb={2}>
          {label}
        </Text>
        {description && (
          <Text size="xs" c="dimmed">
            {description}
          </Text>
        )}
      </Box>
      <Box w="100%" fz="sm">
        {children}
      </Box>
    </Stack>
  );
};
